import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Popover,
  OverlayTrigger,
  PopoverHeader,
  PopoverBody,
} from "react-bootstrap";
import {
  IMAGE_PATH,
  EVENTIFY_FEE,
  STRIPE_FEE,
  STRIPE_FEE_EXTRA,
} from "Constants";
import LocaleStrings from "Languages";

class OrderRefundTicketItems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedUsers: [],
    };
  }

  selectionCallback = (item, index) => {
    this.props.checkAndUncheckItem(item, index);
  };

  priceBreakDown = (item, index) => {
    let { order, stripeCurrencyDetailsList } = this.props;
    let currency = order.currency;
    let ticketFeeType = item.ticketfeetype;
    let ticketQuantity = item.quantity;
    let ticketPrice = item.price;
    let ticketDiscount = item.discount;
    let ticketTaxAmount = item.taxamount;
    let singleTicketPrice = ticketPrice / ticketQuantity;
    let singleTicketDiscount =
      ticketDiscount > 0 ? ticketDiscount / ticketQuantity : 0;
    let singleTicketTaxAmount =
      ticketTaxAmount > 0 ? ticketTaxAmount / ticketQuantity : 0;
    let finalPrice =
      singleTicketPrice - singleTicketDiscount + singleTicketTaxAmount;

    console.log("stripeCurrencyDetailsList :- ", stripeCurrencyDetailsList);

    // Get Fee charges values
    let matchFee = _.filter(stripeCurrencyDetailsList, (obj) => {
      return obj.currency === currency;
    });
    console.log("matchFee :- ", matchFee);
    let eventifyFee =
      matchFee.length > 0 ? matchFee[0].application_fee : EVENTIFY_FEE;
    let stripeFee =
      matchFee.length > 0 ? matchFee[0].stripe_percentage : STRIPE_FEE;
    let stripeExtraFee =
      matchFee.length > 0 ? matchFee[0].stripe_fixed : STRIPE_FEE_EXTRA;

    let feeCharge = (finalPrice / 100) * stripeFee + eventifyFee;

    return (
      <Popover
        title={LocaleStrings.tickets_salesreport_refund_price_breakdown_title}
        id="popover-price-details"
      >
        <PopoverHeader>
          <h3 className="popover-title">
            {LocaleStrings.tickets_salesreport_refund_price_breakdown_title}
          </h3>
        </PopoverHeader>
        <PopoverBody>
          <div className="">
            {LocaleStrings.tickets_salesreport_refund_price_breakdown_text}
          </div>
          <div className="row">
            <hr style={{ margin: 0 }} />
          </div>

          <div className="py-2">
            {`${singleTicketPrice.toFixed(2)} - ${singleTicketDiscount.toFixed(
              2
            )} + ${singleTicketTaxAmount.toFixed(2)} = ${finalPrice.toFixed(
              2
            )}`}
          </div>

          <div className="mt-3">
            {ticketFeeType === "passon"
              ? LocaleStrings.tickets_salesreport_refund_price_fee_text_passon
              : LocaleStrings.tickets_salesreport_refund_price_fee_text_absorb}
          </div>
          <div className="row">
            <hr style={{ margin: 0 }} />
          </div>

          <div className="py-2">{`${feeCharge.toFixed(3)}`}</div>
        </PopoverBody>
      </Popover>
    );
  };

  renderTickets = () => {
    let { item, order, ticketQty, selectedItems } = this.props;

    let coupon = order.couponcode;
    let appliedto = order.appliedto;
    let discount = order.discount;
    let ticketId = item.ticketid;
    let ticketQuantity = item.quantity;
    let ticketPrice = item.price;
    let ticketDiscount = item.discount;
    let ticketTaxAmount = item.taxamount;
    let singleTicketPrice = ticketPrice / ticketQuantity;
    let singleTicketDiscount =
      ticketDiscount > 0 ? ticketDiscount / ticketQuantity : 0;
    let singleTicketTaxAmount =
      ticketTaxAmount > 0 ? ticketTaxAmount / ticketQuantity : 0;

    console.log("coupon :- ", coupon);
    console.log("appliedto :- ", appliedto);
    console.log("discount :- ", discount);

    // This logic is used for printing number
    let printIndex =
      ticketQty === ticketQuantity ? 0 : ticketQty - ticketQuantity;

    singleTicketPrice =
      singleTicketPrice - singleTicketDiscount + singleTicketTaxAmount;

    let ticketDetails = order.tickets_by_orderdetails;

    let getTicketInfo = _.filter(ticketDetails, (o) => {
      return o.id == ticketId;
    });
    let ticketName = getTicketInfo[0].ticketname ?? getTicketInfo[0].ticketname;

    // var selectedItems = this.props.selectedItems;
    console.log("selectedItems ============= ", selectedItems);

    let tickets = [];
    for (let index = 0; index < ticketQuantity; index++) {
      var match = _.findIndex(selectedItems, function (curitem) {
        return curitem.ticketid === item.ticketid && curitem.position === index;
      });

      var checked = false;
      if (match >= 0) {
        checked = true;
      }

      let details = (
        <tr key={`ticket_${index}`}>
          <td>{printIndex + index + 1}</td>
          <td>
            <label className="custom-container-checkbox">
              <input
                type="checkbox"
                onChange={() => this.selectionCallback(item, index)}
                checked={checked}
              />
              <span className="checkmark" />
            </label>
          </td>
          <td>
            <div>{ticketName}</div>
          </td>
          <td>
            <div className="vertical-align-center gap-3">
              {singleTicketPrice.toFixed(2)}
              <OverlayTrigger
                trigger="click"
                placement="right"
                rootClose
                overlay={this.priceBreakDown(item, index)}
              >
                <img
                  src={`${IMAGE_PATH}header-icons/infoicon.png`}
                  className="pointer"
                  alt="info icon"
                />
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      );
      tickets.push(details);
    }

    return tickets;
  };

  render() {
    return <>{this.renderTickets()}</>;
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    stripeCurrencyDetailsList: state.stripeCurrencyDetailsList,
  };
};

export default connect(mapStateToProps, {})(OrderRefundTicketItems);
